import { graphql } from '@/gql';
import type { TransactionQueryInput } from '@/models/transaction';
import { queryExecute } from '@/Utils/graphqlAPI';

export const downloadTransactions = async ({
  phoneNumber,
  partnerCodeName,
  category,
  status,
  startDate,
  endDate,
}: TransactionQueryInput): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query DownloadTransactions(
        $phoneNumber: String
        $partnerCodeName: String
        $status: String
        $category: Float
        $startDate: String
        $endDate: String
      ) {
        downloadTransactions(
          phoneNumber: $phoneNumber
          partnerCodeName: $partnerCodeName
          status: $status
          category: $category
          startDate: $startDate
          endDate: $endDate
        )
      }
    `),
    variables: {
      phoneNumber,
      partnerCodeName,
      category,
      status,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.downloadTransactions;
};
